export const DeHeader = {
    "header": {
        "loggedRole": "Rolle: {role}",
        "loggedWith": "Eingeloggt als {name}",
        "usedProject": "Projekt",
        "usedRoleView": "Teilnehmer"
      },
}